import { jsx as _jsx } from "react/jsx-runtime";
import { Tab, Tabs } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { NAVBAR_HEIGHT } from '../default/theme';
import { accentHover, focusOutline, pillSurface } from './page-primitives';
// Category-pill look for the sticky tabs, floating over the nav bar's blur fan;
// the translucent fill matches the nav search field's treatment.
// eslint-disable-next-line react-refresh/only-export-components
export const PillTab = styled(Tab)(({ theme }) => ({
    ...pillSurface(theme),
    minHeight: 0,
    minWidth: 0,
    backgroundColor: alpha(theme.palette.surface2, 0.7),
    backdropFilter: 'blur(2px) saturate(1.8)',
    // Still translucent so the blur fan shows through; the border carries the emphasis.
    '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.secondary.main, 0.7),
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        fontWeight: 600
    },
    '&:not(.Mui-selected)': accentHover(theme),
    ...focusOutline(theme)
}));
/** Negative counterpart of each gutter, used to bleed the strip through them. */
const negateGutters = (gutters) => Object.fromEntries(Object.entries(gutters).map(([breakpoint, size]) => [breakpoint, `-${size}`]));
/**
 * Sticky, horizontally scrollable row of {@link PillTab}s pinned under the
 * navbar. The scroller keeps the selected pill in view when it changes.
 */
export const PillTabs = ({ gutters = { xs: '1rem', sm: '1.5rem' }, sx, children, ...tabsProps }) => {
    const bleed = negateGutters(gutters);
    return (_jsx(Tabs, { variant: 'scrollable', scrollButtons: false, sx: [
            {
                // Pin under the navbar; the transparent row lets the blur fan
                // back the pills (same z as the AppBar, later in the DOM).
                position: 'sticky',
                top: NAVBAR_HEIGHT,
                zIndex: 50,
                minHeight: 0,
                mx: bleed,
                '& .MuiTabs-indicator': { display: 'none' },
                '& .MuiTabs-flexContainer': {
                    gap: '0.5rem',
                    // Inside the scroller — its overflow clips the focus ring otherwise.
                    py: '0.625rem',
                    // Sized to the pills so the trailing padding lands after the
                    // last pill, not at the 100% mark.
                    width: 'max-content',
                    minWidth: '100%',
                    px: gutters
                }
            },
            ...(Array.isArray(sx) ? sx : [sx])
        ], ...tabsProps, children: children }));
};
//# sourceMappingURL=pill-tabs.js.map